// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const actions = {
  fetchConfigLeaveApproval(_, payload) {
    return ApiService.fetchConfigLeaveApproval(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  updateConfigLeaveApproval(_, payload) {
    return ApiService.updateConfigLeaveApproval(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
}
